import * as Animate from "react-reveal";
import Avatar1 from "../../../assets/images/png/talent-leader.webp";
import Avatar2 from "../../../assets/images/png/avatars/4.webp";
import Avatar3 from "../../../assets/images/png/avatars/5.webp";
import Avatar4 from "../../../assets/images/png/avatars/6.webp";

const openRoles = [
  { number: "01", title: "Senior Frontend Engineer", ready: "8 ready" },
  { number: "02", title: "Data Analyst", ready: "14 ready" },
  { number: "03", title: "Product Manager", ready: "9 ready" },
  { number: "04", title: "Business Analyst", ready: "11 ready" },
];

const OurStrategySection = () => {
  return (
    <section
      className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4"
      id="proof"
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center gap-3 text-[#956000] font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                The access problem
              </p>

              <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight font-poppins font-black mb-6 tracking-[-0.03em]">
                <span className="text-default">
                  Global Talent Is Everywhere.
                </span>{" "}
                <span className="text-primary">Access Is Not.</span>
              </h2>

              <p className="text-gray text-base md:text-lg font-poppins leading-loose max-w-xl">
                Thousands of skilled professionals are already prepared to work
                globally. Growing companies still have to stitch together
                recruiters, payroll providers and compliance tools just to find,
                hire and operate a team.
              </p>
              <strong className="text-primary font-poppins text-xl md:text-2xl block mt-6">
                Utiva connects both sides.
              </strong>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div className="bg-primary rounded-3xl p-6 md:p-7 shadow-course-feature-lg">
              <div className="flex justify-between items-center gap-3 pb-4 mb-2 border-b border-white/15">
                <span className="text-secondary tracking-widest text-xs font-extrabold font-poppins">
                  LIVE TALENT DEMAND
                </span>
                <b className="text-indigo-200 text-xs font-poppins">
                  Updated today
                </b>
              </div>

              {openRoles.map((role) => (
                <article
                  key={role.number}
                  className="grid items-center gap-3 py-3 border-b border-white/10"
                  style={{ gridTemplateColumns: "34px 1fr auto" }}
                >
                  <span className="text-indigo-200 font-poppins text-sm font-extrabold">
                    {role.number}
                  </span>
                  <p className="text-white font-poppins m-0 font-bold text-base md:text-lg">
                    {role.title}
                  </p>
                  <strong className="text-white bg-white/10 rounded-full px-3 py-1.5 text-xs font-poppins">
                    {role.ready}
                  </strong>
                </article>
              ))}

              <a
                href="https://app.utiva.co/signup?goal=employer"
                target="_blank"
                rel="noreferrer noopener"
                className="bg-secondary text-primary rounded-xl flex items-center justify-between font-poppins font-extrabold mt-5 px-4 py-3.5 text-sm md:text-base custom-btn"
              >
                Tell us who you need <span aria-hidden="true">↗</span>
              </a>
            </div>
          </Animate.Fade>
        </div>

        <Animate.Fade bottom>
          <div className="border-l-4 border-secondary bg-white rounded-r-2xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 mt-8 md:mt-10 px-6 py-6 md:px-8">
            <strong className="text-primary font-poppins text-lg md:text-xl">
              Talent access is the wedge.
            </strong>

            <div className="flex items-center gap-4">
              <div className="flex items-center">
                {[Avatar1, Avatar2, Avatar3, Avatar4].map((avatar, index) => (
                  <img
                    key={index}
                    src={avatar}
                    alt=""
                    className={`w-11 h-11 rounded-full object-cover border-2 border-white ${
                      index !== 0 ? "-ml-2.5" : ""
                    }`}
                  />
                ))}
              </div>
              <p className="m-0 grid gap-0.5">
                <b className="text-primary font-poppins text-base">
                  Real people. Ready to work.
                </b>
                <small className="text-gray font-poppins text-sm max-w-xs">
                  Assessed across technology and business roles.
                </small>
              </p>
            </div>

            <span className="text-default font-poppins font-bold text-lg md:text-xl">
              Global workforce infrastructure is the platform.
            </span>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default OurStrategySection;
